<script>
import axios from "axios";
import Swal  from "sweetalert2";
import dayjs from "dayjs";

export default {
  data() {
    return {
      loading: false,
      reply: "",
    };
  },
  props: ["response", "contract"],
  inject: ["modals"],
  methods: {
    async sendReply() {
      this.loading = true;
      try {
        await axios.post(`/v3/feedback/responses/${this.response.id}/reply`, {
          manager_response: this.reply,
          subscription_id:  this.contract.id,
          from:             this.from
        });
        this.success();
      } catch (err) { this.error(err) }
      this.modals.reply.response = false;
      this.response.manager_response = this.reply;
      this.response.manager_response_date = dayjs().format("DD MMM YYYY");
      this.loading = false;
    },
    success() {
			Swal.fire(this.$t("general.success"), this.$t("daily_operations.reviews.reply_sent_success"), "success");
		},
    error(error) {
      return Swal.fire(this.$t("general.error"), this.$t("general.contact_support") + JSON.stringify(error.response?.data), "error");
    }
  }
}
</script>

<template>
  <div>
    <div class="pb-2 pt-3 d-flex flex-column">
      <textarea class="w-100 reply-textarea" v-model="reply" rows="7" :placeholder="$t('surveys_responses.reply_response_placeholder')"></textarea>
    </div>

    <div class="footer-nav d-flex justify-content-between mt-3 mb-1">
      <button class="btn btn-outline-secondary" @click="modals.reply.response = false">
        {{ $t("surveys_list.cancel") }}
      </button>

      <button class="btn btn-primary" :disabled="reply.length <= 0 || loading" @click="sendReply">
        {{ $t("daily_operations.reviews.send_reply") }}
      </button>
    </div>
  </div>
</template>
